import { useState } from 'react';

import { WorkbenchRunStatusContext } from './workbench-run-status-context.js';
import { createWorkbenchRunStatusStore } from './workbench-run-status-store.js';

import type { ReactNode } from 'react';

/**
 * Provides a run-status store scoped to one workbench pane. Must sit outside the
 * runtime's Suspense boundary so the store instance survives fallback renders,
 * which is when the thread runtime writing to it is re-created.
 */
export function WorkbenchRunStatusProvider({ children }: { children: ReactNode }) {
	const [store] = useState(() => createWorkbenchRunStatusStore());
	return <WorkbenchRunStatusContext value={store}>{children}</WorkbenchRunStatusContext>;
}
